<script>
export default {
  name: "FloatingButtonContainer",
  props: {
    placement: {
      type: String,
      default: "bottom-right"
    }
  }
};
</script>

<template>
  <div class="floating-button-container" :placement="placement">
    <slot></slot>
  </div>
</template>

<style>
.floating-button-container {
  position: fixed;
  padding: 0 1.5rem 1.5rem 0;
  z-index: 2;
}

@media (min-width: 1024px) {
  .floating-button-container {
    padding: 0 3rem 3rem 0;
  }
}

.floating-button-container[placement="bottom-right"] {
  bottom: 0;
  right: 0;
}

.floating-button-container[placement="bottom-left"] {
  bottom: 0;
  left: 0;
}

.floating-button-container[placement="top-right"] {
  top: 0;
  right: 0;
}

.floating-button-container[placement="top-left"] {
  top: 0;
  left: 0;
}
</style>
